export default __webpack_public_path__ + "436dfb896540381b5a5f9bd325bc510c.ttf";